import { PrayerAudio } from "./prayers/PrayerAudio";

// The former generic Byzantine hymn was not verified as this Akathist.
export default function AkathistAudio() {
  return <PrayerAudio prayerId="akathist" prefix="east-west-akathist" />;
}